module.exports = __webpack_public_path__ + "img/clock.b170df57.gif";